import { useEffect, useState } from "react";
import ContentRouter from "./pages/ContentRouter";
import BlogRouter from "./pages/blog/BlogRouter";
import Landing from "./pages/Landing";
import Demo from "./pages/Demo";
import App from "./App";
import { router } from "./lib/router";
import ContactPage from "./pages/ContactPage";

/**
 * AppRouter - Main routing component that handles path-based rendering
 * This component is separate from the actual app implementations to avoid
 * hook ordering issues with conditional rendering.
 */
export default function AppRouter() {
  const [currentPath, setCurrentPath] = useState<string>('/');
  
  // Use our router to handle path changes
  useEffect(() => {
    // Subscribe to router changes
    const unsubscribe = router.subscribe((path) => {
      setCurrentPath(path);
    });
    
    // Cleanup subscription
    return unsubscribe;
  }, []);

  // Route to appropriate component based on path
  if (currentPath.startsWith("/docs")) {
    return <ContentRouter />;
  }
  if (currentPath.startsWith("/blog") || currentPath.startsWith("/learn")) {
    return <BlogRouter />;
  }
  
  // Show landing page when at root
  if (currentPath === "/" || currentPath === "/landing") {
    return <Landing />;
  }
  
  // Test page for styling
  if (currentPath === "/demo") {
    return <Demo />;
  }
  // Contact page
  if (currentPath === "/contact") {
    return <ContactPage />;
  }
  
  // Show main app for /app or default to app view for other routes
  return <App />;
}
